export enum LinkedinTaskStatusUpdateBy {
  App = 'APP',
  ChromeExtension = 'CHROME_EXTENSION',
}
